export default {
  getByWeek: `query findMenuEventsByWeek($startDate: String!, $endDate: String!, $office: Int!){
    findMenuEventsByWeek(startDate: $startDate, endDate: $endDate, office: $office){
      canSubmit,
      menuEventsInfo {
        id
        office
        date
        event
        time
        mealsInfo{
          id
          name
          dietInfo{
            id
            name
          }
        }
      }
    }
  }`,
  get: `query findMenuEvent($date: String!, $event: Int!, $office: Int!){
    findMenuEventsByWeek(date: $date, event: $event, office: $office){
      id
      office
      date
      event
      time
      mealsInfo{
        name
        dietInfo{
          id
          name
          dietInfo{
            id
            name
          }
        }
      }
    }
  }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/weeklyMenu.js